<template>
	<div class="vcx-ml-600-lg vcx-flex vcx-overflow-scroll">
		<VcxPortfolioPerformanceReturnJumboChip
			v-for="(returnData, index) in props.data"
			:key="index"
			:return-data="returnData"
			:selected-chip="props.selectedChip"
			:show-return-indicator="props.showReturnIndicator"
			class="vcx-mr-100"
			@return-chip-selected="emit('return-chip-selected', $event)"
		/>
	</div>
</template>

<script setup lang="ts">
import { PerformanceReturnJumboChip, PerformanceReturnJumboChipEnum } from 'types/performance-portfolio';
import VcxPortfolioPerformanceReturnJumboChip from '@components/vcx/vcx-portfolio-performance-return-jumbo-chip.vue';

interface Props {
	data: Array<PerformanceReturnJumboChip>;
	selectedChip: PerformanceReturnJumboChipEnum;
	showReturnIndicator?: boolean;
}

interface Emits {
	(e: 'return-chip-selected', value: PerformanceReturnJumboChipEnum): void;
}

const props = withDefaults(defineProps<Props>(), {
	showReturnIndicator: true
});

const emit = defineEmits<Emits>();
</script>
